import Reports from '@/views/reports/Reports';
import ReportOverdueLoan from '@/views/reports/ReportOverdueLoan';
import ReportExtendedLoanTerm from '@/views/reports/ReportExtendedLoanTerm';
import ReportLoan from '@/views/reports/ReportLoan';
import ReportLoanRepayment from '@/views/reports/ReportLoanRepayment';
import CreditAccountBalance from '@/views/reports/CreditAccountBalance';
import ReportEndDay from '@/views/ReportEndDay/ReportEndDay';
import ReportEndDayScreen1 from '@/views/ReportEndDay/ReportEndDayScreen1';
import ReportEndDayScreen2 from '@/views/ReportEndDay/ReportEndDayScreen2';
import { requiresReportAccess } from '@/router/helpers';

export default [
  {
    path: '/reports',
    component: Reports,
    beforeEnter: requiresReportAccess,
    meta: {
      group: 'reports',
      roles: ['ADMINISTRATOR', 'CHIEF_LOAN_OFFICER', 'ACCOUNTANT'],
      title: 'Тайлан',
    },
    children: [
      {
        path: 'loan',
        name: 'ReportLoan',
        component: ReportLoan,
      },
      {
        path: 'overdue-loan',
        name: 'ReportOverdueLoan',
        component: ReportOverdueLoan,
      },
      {
        path: 'extendedLoanTerm',
        name: 'ReportExtendedLoanTerm',
        component: ReportExtendedLoanTerm,
      },
      {
        path: 'loan-repayment',
        name: 'ReportLoanRepayment',
        component: ReportLoanRepayment,
      },
      {
        path: 'end-day',
        component: ReportEndDay,
        children: [
          {
            path: '',
            name: 'ReportEndDay',
            component: ReportEndDayScreen1,
          },
          {
            path: 'completed',
            name: 'ReportEndDayCompleted',
            component: ReportEndDayScreen2,
          },
        ],
      },
      {
        path: 'credit-account-balance',
        name: 'CreditAccountBalance',
        component: CreditAccountBalance,
      },
    ],
  },
];
